<div [formGroup]="form" *ngIf="form">
  <app-form-field-group>
    <app-row class="no-gutters">
      <app-col cols="7">
        <mat-form-field appearance="outline" class="w-100">
          <input matInput type="number" [placeholder]="'Placeholder.Weight' | translate" formControlName="weight" />
        </mat-form-field>
      </app-col>
      <app-col cols="5">
        <app-dropdown formControlName="unit" [list]="units" [placeholder]="'Inputs.Unit' | translate"></app-dropdown>
      </app-col>
    </app-row>
  </app-form-field-group>
</div>
